import { render, staticRenderFns } from "./RecommendableReasonPage.vue?vue&type=template&id=57b7c596&scoped=true"
import script from "./RecommendableReasonPage.vue?vue&type=script&lang=js"
export * from "./RecommendableReasonPage.vue?vue&type=script&lang=js"
import style0 from "./RecommendableReasonPage.vue?vue&type=style&index=0&id=57b7c596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b7c596",
  null
  
)

export default component.exports